export default class cutter extends PIXI.Container {
    constructor(texture, renderTexture, cookieTexture) {
        super();
        this._view = new PIXI.Sprite(texture);
        this._view.anchor.set(0.5);
        this._view.scale.set(0.8);
        this.addChild(this._view);

        //console.log(texture);
        let t = texture.textureCacheIds[0].slice(0, texture.textureCacheIds[0].length - 4);
        //console.log(t);
        this._shadow = new PIXI.Sprite(P3.assets.texture(t + "_shadow"));
        this._shadow.anchor.set(0.5);
        this._shadow.scale.set(0.8);
        this._shadow.position.set(0, 25);
        this.addChildAt(this._shadow, 0);

        this._animationPlaying = false;
        this._renderTexture = renderTexture;
        this._cookieTexture = cookieTexture;

        this._signals = {};
        this._signals.clickAnimationFinished = new P3.utils.MiniSignal();
        this._signals.clickAnimationStart = new P3.utils.MiniSignal();
    }

    clickAnimation(){
        let down = new P3.utils.TWEEN.Tween(this.scale, this.tweens)
            .to({
                x: .84,
                y: .84
            }, 150)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .onComplete(()=> {
                this._signals.clickAnimationFinished.dispatch(this._renderTexture);
            })
            .onStart(()=> {
                this._animationPlaying = true;
                this._signals.clickAnimationStart.dispatch(this._renderTexture);
                P3.audio.playSound('sfx_press_cutter_00');
            })
            .start();

        let up = new P3.utils.TWEEN.Tween(this.scale, this.tweens)
            .to({
                x: 1,
                y: 1
            }, 150)
            .onComplete(()=>{
                this._animationPlaying = false;
            })
            .easing(P3.utils.TWEEN.Easing.Linear.None);

        down.chain(up);

        let downShadow = new P3.utils.TWEEN.Tween(this._shadow, this.tweens)
            .to({
                y: "-25", alpha: 0
            }, 150)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .start();

        let upShadow = new P3.utils.TWEEN.Tween(this._shadow, this.tweens)
            .to({
                y: "+25", alpha: 1
            }, 150)
            .easing(P3.utils.TWEEN.Easing.Linear.None);


        downShadow.chain(upShadow);

        let downShadow2 = new P3.utils.TWEEN.Tween(this._shadow, this.tweens)
            .to({
                alpha: 0
            }, 150)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .start();

        let upShadow2 = new P3.utils.TWEEN.Tween(this._shadow, this.tweens)
            .to({
                alpha: 1
            }, 150)
            .easing(P3.utils.TWEEN.Easing.Linear.None);

        downShadow2.chain(upShadow2);
    }

    moveThenClick(position){
        new P3.utils.TWEEN.Tween(this, this.tweens)
            .to({
                x: position.x, y: position.y
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(()=>{
                this.clickAnimation();
            })
            .onStart(()=>{
                this._animationPlaying = true;
            })
            .start();
    }
}